import DashCardHeading from './DashCardHeading.component';

export default DashCardHeading;